// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__l-Ib6","popup":"Popup_popup__EZ570","title":"Popup_title__mI-9N","buttonBar":"Popup_buttonBar__uKA4J"};